/**
 * Every word this application says.
 *
 * Russian only, and that is a decision rather than an omission: every admin facing string in
 * the project is already russian (admintgfront, the notifications of adminbackapi), the admin
 * list is a handful of people, and a second catalogue nobody reads would drift from the first.
 *
 * The shape is still the one that makes adding a language cheap. Components hold no literals,
 * the keys are a union derived from this object, and adding english later is adding a second
 * object of the same type - at which point a missing key becomes a compile error, exactly as
 * in clientwebfront.
 */

export const ru = {
  "app.title": "Админ-приложение",
  "app.loading": "Загрузка…",
  "app.outside": "Откройте приложение из админ-бота — только так телеграм подписывает вход.",
  "app.forbidden": "У вас нет доступа к админ-приложению.",
  "app.error": "Что-то пошло не так. Попробуйте обновить страницу.",
  "app.retry": "Повторить",

  "copy.hint": "Скопировать id",
  "copy.aria": "Скопировать id {value}",
  "copy.done": "Скопировано",
  "copy.failed": "Не скопировалось",

  "tabs.tickets": "Заявки",
  "tabs.refunds": "Возвраты",
  "tabs.grants": "Начисления",
  "tabs.scrapers": "Скраперы",
  "tabs.stats": "Статистика",

  "tickets.filter.open": "Открытые",
  "tickets.filter.closed": "Закрытые",
  "tickets.filter.any": "Все",
  "tickets.empty": "Заявок нет",
  "tickets.more": "Показать ещё",
  "tickets.loading": "Загрузка заявок…",
  "tickets.waiting": "Ждёт ответа",
  "tickets.blocked": "Бот заблокирован",
  "tickets.notClient": "Не зарегистрирован",
  "tickets.unknownClient": "Регистрация неизвестна",
  "tickets.number": "Обращение №{id}",
  "tickets.messages": "сообщений: {count}",
  "tickets.back": "К списку",
  "tickets.closed": "Обращение закрыто",
  "tickets.closedBy": "Закрыл: {admin}",
  "tickets.payments": "Платежи клиента",
  "tickets.filterByUser": "Заявки клиента",
  "tickets.clearUser": "Показать все заявки",

  "thread.client": "Клиент",
  "thread.support": "Поддержка",
  "thread.bot": "Бот",
  "thread.attachment": "вложение: {type} — клиента попросили описать проблему текстом",
  "thread.delivered": "доставлено",
  "thread.pending": "статус неизвестен",
  "thread.failed": "не доставлено",
  "thread.empty": "Сообщений пока нет",

  "reply.placeholder": "Ответ клиенту",
  "reply.send": "Ответить",
  "reply.sendAndClose": "Ответить и закрыть",
  "reply.close": "Закрыть обращение",
  "reply.sending": "Отправляем…",
  "reply.tooLong": "Слишком длинный ответ: {length} из {max} символов",
  "reply.blocked": "Клиент заблокировал бота — ответ до него не дойдёт.",
  "reply.closedNotice": "Обращение закрыто. Клиент может написать снова — откроется новое.",
  "reply.confirmClose": "Закрыть обращение без ответа?",
  "reply.confirmYes": "Закрыть",
  "reply.confirmNo": "Отмена",
  "reply.retry": "Отправить ещё раз",

  "refunds.queue": "Заявки на возврат",
  "refunds.byUser": "Платежи клиента",
  "refunds.userPlaceholder": "telegram id клиента",
  "refunds.find": "Найти",
  "refunds.badUser": "Telegram id — это число",
  "refunds.empty": "Заявок на возврат нет",
  "refunds.noPayments": "У клиента {user} нет платежей, которые можно вернуть",
  "refunds.select": "Оформить возврат",
  "refunds.preparing": "Считаем…",
  "refunds.confirmTitle": "Возврат платежа {id}",
  "refunds.client": "Клиент:",
  "refunds.stars": "Звёзды к возврату: {amount}",
  "refunds.tokens": "Токенов было начислено: {tokens}",
  "refunds.clawback": "К списанию с баланса: {tokens}",
  "refunds.unrecovered": "Уже потрачено и не вернётся: {tokens}",
  "refunds.limitAfter": "Лимит после возврата: {limit}",
  "refunds.previousRefunds": "Возвратов у клиента ранее: {count}",
  "refunds.shortfall": "Внимание: потрачено больше {percent}% пакета.",
  "refunds.confirm": "Подтвердить возврат",
  "refunds.reject": "Отказать в возврате",
  "refunds.cancel": "Отмена",
  "refunds.working": "Возвращаем…",
  "refunds.rejecting": "Отказываем…",
  "refunds.rejected":
    "В возврате отказано: клиент получил уведомление. Повторно запросить возврат он не сможет — при необходимости верните вручную через поиск по клиенту.",
  "refunds.rejectedUnnotified":
    "В возврате отказано, но уведомление клиенту не доставлено. Повторно запросить возврат он не сможет.",
  "refunds.rejectedBefore":
    "Клиенту уже отказано в возврате этой покупки ({date}). Подтверждайте, только если решение пересмотрено.",
  "refunds.done": "Возврат сделан: звёзды вернулись, токены списаны.",
  "refunds.starsFailed": "Звёзды не вернулись, заявка возвращена в очередь. Ничего не списано.",
  "refunds.clawbackFailed":
    "Звёзды вернулись, но токены не списаны. Платёж остался в очереди — повторите, это безопасно.",
  "refunds.status.paid": "оплачен",
  "refunds.status.requested": "запрошен возврат",
  "refunds.status.refunding": "возврат в процессе",
  "refunds.status.refunded": "возвращён",
  "refunds.status.created": "не оплачен",
  "refunds.status.cancelled": "отменён",
  "refunds.status.rejected": "в возврате отказано",
  "refunds.reason": "Причина: {reason}",

  "scrapers.title": "Добавить скрапер в чат",
  "scrapers.hint":
    "Сначала заведите аккаунт скрапера в чат вручную, затем пришлите сюда ссылку — приложение найдёт, какой из скраперов там оказался.",
  "scrapers.placeholder": "https://t.me/somechannel",
  "scrapers.resolve": "Посмотреть чат",
  "scrapers.add": "Найти скрапер и добавить",
  "scrapers.searching": "Ищем скрапер в чате, это может занять до трёх минут…",
  "scrapers.resolved": "Чат: {title}",
  "scrapers.added": "Скрапер {number} найден в чате «{title}». chat_id: {chatId}",
  "scrapers.addedShort":
    "Чат начнёт читаться в течение нескольких минут, если его отслеживают клиенты. Алерты «Чат без скрапера» по нему больше не придут.",
  "scrapers.empty": "Пришлите ссылку на чат",

  // taking a chat off monitoring: the opposite operation on the same object, so it lives on the
  // same screen - but with its own link field and its own resolve. Sharing the one above would
  // mean adding a scraper somewhere arms the button that takes a chat off monitoring, and would
  // hide this whole section until an unrelated search had succeeded.
  //
  // Its labels must differ from the scrapers.* ones word for word: two forms asking for a chat
  // link are now on one screen, and identical captions confuse an operator as much as a test.
  "block.title": "Снять чат с мониторинга",
  "block.hint":
    "Обычно по просьбе владельца чата. Чат перестанет читаться сразу, сохранённые сообщения по " +
    "нему удаляются безвозвратно, скрапер выйдет из чата, а клиенты получат уведомление в течение " +
    "нескольких минут.",
  "block.placeholder": "Ссылка на чат, который снимаем",
  "block.resolve": "Найти чат",
  "block.resolved": "Снимаем чат: {title}",
  "block.look": "Что будет затронуто",
  "block.reasonPlaceholder": "Почему снимаем: просьба владельца, номер тикета…",
  "block.trackings": "Затронуто отслеживаний: {count}",
  "block.clients": "Клиентов будет уведомлено: {count}",
  "block.notifications": "Сообщений будет удалено из истории: {count}",
  "block.confirm": "Снять с мониторинга",
  "block.cancel": "Отмена",
  "block.working": "Выполняем…",
  "block.alreadyBlocked": "Этот чат уже снят с мониторинга. Вернуть его можно ниже, по chat_id.",
  "block.done": "Чат «{title}» снят с мониторинга. Клиенты получат уведомление в течение нескольких минут.",

  // putting a chat back. By chat_id and not by a link: the scraper has left the chat by then, so
  // a link to it may no longer resolve, and a chat nobody can resolve would be a chat nobody can
  // put back. One step and no confirmation - nothing is deleted and nobody is told.
  "unblock.title": "Вернуть чат на мониторинг",
  "unblock.hint":
    "Если чат сняли по ошибке или владелец передумал. chat_id печатается в подтверждении при снятии.",
  "unblock.placeholder": "chat_id, например -1001234567890",
  "unblock.button": "Вернуть на мониторинг",
  "unblock.working": "Выполняем…",
  "unblock.done": "Чат снова на мониторинге.",
  "unblock.notBlocked": "Этот чат не был снят с мониторинга.",
  // shown after every success: unblocking undoes the first of the three steps of blocking and
  // none of the others, and an operator who thinks otherwise waits for messages that never come
  "unblock.warning":
    "⚠️ Это возвращает только мониторинг. Удалённая история чата не восстановлена, и скрапер в чат " +
    "не вернулся — если он выходил, заведите его заново через «Найти скрапер и добавить».",

  // the list of message authors who objected: not tied to a resolved chat, an author writes
  // in many of them
  "authors.title": "Возражение автора сообщений",
  "authors.hint":
    "Человек, чьи сообщения читает сервис, просит их не обрабатывать. Внесите его telegram id в " +
    "список исключений. Уже сохранённые сообщения так не удаляются — только по ссылкам или вместе с чатом.",
  "authors.placeholder": "telegram id автора, например 123456789",
  "authors.block": "Внести в список",
  "authors.unblock": "Убрать из списка",
  "authors.working": "Выполняем…",
  "authors.blocked": "Автор внесён в список исключений.",
  "authors.already": "Автор уже был в списке исключений.",
  "authors.unblocked": "Автор убран из списка исключений.",
  "authors.notFound": "Этого автора не было в списке исключений.",
  "authors.notEnforced":
    "⚠️ Обработчик сообщений этот список пока не читает: фильтра в chatsreader нет, сообщения автора " +
    "продолжают проверяться и попадать клиентам. Обещание из уведомления участникам чатов («сообщения " +
    "отбрасываются в самом начале обработки») не выполняется, пока фильтр не реализован. Эту " +
    "функциональность нужно реализовать.",

  "error.ScraperInChatNotFoundError": "Ни один скрапер не состоит в этом чате.",
  "error.ChatRowParsingError": "Не похоже на ссылку или username телеграм-чата.",
  "error.UsernameHashParsingError": "Не похоже на ссылку или username телеграм-чата.",
  "error.ChatNotFoundError": "Чат не найден.",
  "error.PrivateChatError": "Это приватный чат, скрапер туда не попадёт.",
  "error.ScraperSessionNotFoundError": "Нет доступной сессии скрапера.",
  "error.ChatScraperNotFoundError": "Ни один скрапер не состоит в этом чате.",
  "grants.title": "Начислить токены",
  "grants.hint": "Токены попадут на баланс клиента, и клиент получит уведомление. Отменить начисление нельзя.",
  "grants.userPlaceholder": "telegram id клиента",
  "grants.tokensPlaceholder": "сколько токенов",
  "grants.commentPlaceholder": "комментарий для клиента (необязательно)",
  "grants.submit": "Начислить",
  "grants.badUser": "telegram id — это целое число.",
  "grants.badTokens": "Начислить можно от 1 до {max} токенов.",
  "grants.confirmTitle": "Подтвердите начисление",
  "grants.client": "Клиент:",
  "grants.tokens": "Токенов: {tokens}",
  "grants.comment": "Комментарий: {comment}",
  "grants.confirm": "Подтвердить начисление",
  "grants.cancel": "Отмена",
  "grants.working": "Начисляем…",
  "grants.done": "Начислено {tokens} токенов. Клиент уведомлён.",
  "grants.notNotified": "Токены начислены, но сообщение клиенту не доставлено. Повторять не нужно.",
  "grants.replayed": "Это начисление уже было сделано, повторно ничего не начислено.",

  "stats.title": "Статистика",
  "stats.hint": "Сколько клиентов пришло и сколько из них пользовались ботом. Нажмите на столбец, чтобы увидеть число.",
  "stats.period.day": "Сутки",
  "stats.period.month": "Месяц",
  "stats.period.year": "Год",
  "stats.loading": "Загрузка статистики…",
  "stats.mode.sum": "Сумма",
  "stats.mode.change": "Изменение",
  "stats.new.title": "Новые пользователи",
  "stats.new.base": "Всего пользователей: {count}",
  "stats.new.total": "Новых за период: {count}",
  "stats.new.value": "Новых пользователей: {count}",
  "stats.active.title": "Активные пользователи",
  "stats.active.total": "Активных за период: {count}",
  "stats.active.value": "Активных пользователей: {count}",
  "stats.active.change": "Изменение: {change}",
  "stats.active.changeDetail": "Активных: {count}, {previous}: {before}",
  "stats.previous.hour": "часом раньше",
  "stats.previous.day": "днём раньше",
  "stats.previous.month": "месяцем раньше",
  "stats.hourRange": "{day}, {from}–{to}",
  "stats.current.hour": "Час ещё идёт",
  "stats.current.day": "День ещё идёт",
  "stats.current.month": "Месяц ещё идёт",
  "stats.footnote":
    "Время — UTC. Активный — хотя бы одно списание токенов за период. Удалённые аккаунты не учитываются.",

  "error.ClientNotFoundError": "Клиент не найден — этот telegram id ещё не зарегистрирован в боте.",
  "error.PaymentNotFoundError": "Платёж не найден.",
  "error.RefundNotPossibleError": "Этот платёж вернуть нельзя.",
  "error.RefundRejectNotPossibleError":
    "Отказать можно только по заявке клиента, которая ещё ждёт решения: по этому платежу отказывать не в чем.",
  "error.TicketNotFoundError": "Обращение не найдено.",
  "error.TicketClosedError": "Обращение уже закрыто.",
  "error.TelegramForbiddenError": "Клиент заблокировал бота — ответ до него не дойдёт.",
  "error.backend": "Внутренняя ошибка, смотрите логи.",
  "error.network": "Сервис не отвечает. Попробуйте ещё раз.",

  "time.justNow": "только что",
  "time.minutes": "{count} мин назад",
  "time.hours": "{count} ч назад",
  "time.days": "{count} дн назад",
} as const;

export type TranslationKey = keyof typeof ru;

/**
 * Look up a phrase and substitute the values named in it.
 *
 * Substitution is a plain replaceAll of {name}: the phrases here have at most two of them and
 * a formatter library would be more code than the strings it formats.
 */
export function t(key: TranslationKey, values?: Record<string, string | number>): string {
  let phrase: string = ru[key];
  if (values) {
    for (const [name, value] of Object.entries(values)) {
      phrase = phrase.replaceAll(`{${name}}`, String(value));
    }
  }
  return phrase;
}
